import React, { useState } from "react";
// Import React FilePond
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { registerPlugin } from "react-filepond";
import colis from '../../assets/images/colis.png';
// Import the plugin code
import { Box } from "@mui/material";
import { UploadIcon } from "@radix-ui/react-icons";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { ADD_LIVRAISON } from "../../Utils/constant";
import { store } from "../../services/service";
import { useStoreLivraison } from "../../store/livraisonStore";
import { SubmitButton } from "../Widget/SubmitButton";
// Register the plugins
registerPlugin(
    FilePondPluginImageExifOrientation,
    FilePondPluginImagePreview,
    FilePondPluginImageResize
);
export const LivraisonForm = ({ numeroTicket, handleNext }) => {
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);
    const code = useStoreLivraison();
    const [verso, setVerso] = useState([]);
    const [recto, setRecto] = useState([]);
    const [bordereau, setBordereau] = useState([]);
    const [statusLivraison, setStatusLivraison] = useState(false)
    const [error, setError] = useState(null)
    const handleChangeCniVerso = (e) => {
        const selectedFiles = e.target.files;
        if (verso.length <= 0) {
            const newFiles = Array.from(selectedFiles)
            setVerso(prevFiles => [...prevFiles, ...newFiles])
        } else {
            const newFiles = Array.from(selectedFiles)
            setVerso(newFiles)
        }
    }

    const handleChangeLivraison = (e) => {
        const selectedFiles = e.target.files;
        if (bordereau.length <= 0) {
            const newFiles = Array.from(selectedFiles)
            setBordereau(prevFiles => [...prevFiles, ...newFiles])
        } else {
            const newFiles = Array.from(selectedFiles)
            setBordereau(newFiles)
        }
    }

    const handleChangeCniRecto = (e) => {
        const selectedFiles = e.target.files;
        if (recto.length <= 0) {
            const newFiles = Array.from(selectedFiles)
            setRecto(prevFiles => [...prevFiles, ...newFiles])
        } else {
            const newFiles = Array.from(selectedFiles)
            setRecto(newFiles)
        }
    }

    const submit = (data) => {
        setError(null)
        setIsSubmit(true)
        const requestData = { ...data, numeroTicket: numeroTicket, bordereau: bordereau[0], listFichierDesignation: ['CNI_VERSO', 'CNI_RECTO'], listFichierPieces: [verso[0], recto[0]], statusLivraison: '' }
        store(ADD_LIVRAISON, 'multipart/form-data', requestData).then((res) => {
            if (res.status === 200) {
                setStatusLivraison(true)
                setIsSubmit(null)
                toast.success('Livraison effectué')
            }
        }).catch((err) => {
            setIsSubmit(false)
            setStatusLivraison(false)
            setError(err?.response?.data?.donnee)
        })
    }
    return (
        <>
            <p className="text-red-600">{error}</p>
            {
                !statusLivraison ?
                    <form onSubmit={handleSubmit(submit)} className="w-full flex flex-col h-full mt-6 mb-12">
                        <div className="flex xl:flex-row mt-3 lg:flex-row md:flex-row flex-col items-center gap-x-3">
                            <div className="grid lg:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-2  w-full">
                                <div>
                                    <label className="form-control  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">
                                                Numéro série <span className="text-red-500">*</span>
                                            </span>
                                        </div>
                                        <input

                                            {...register('numeroSerie', { required: true })}
                                            type="text"
                                            placeholder="Numéro de série l'équipement"
                                            className="input input-bordered text-gray-500 w-full h-10 text-sm font-semibold"
                                        />
                                    </label>

                                    <label className="form-control  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">
                                                IMSI SIM Pack Mobile <span className="text-red-500">*</span>
                                            </span>
                                        </div>
                                        <input

                                            {...register('imsi', { required: true })}
                                            type="text"
                                            placeholder="IMSI SIM"
                                            className="input input-bordered text-gray-500 w-full h-10 text-sm font-semibold"
                                        />
                                    </label>

                                    <label className="form-contro  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium ">
                                                Numéro du FTTH <span className="text-red-500">*</span>
                                            </span>
                                        </div>
                                        <label className="input input-bordered flex items-center gap-2">
                                            <input
                                                {...register('numeroFtth', { required: true })}
                                                type="text"
                                                className="h-10 grow"
                                                placeholder="Numéro du FTTH"
                                            />
                                            <p>@mtn.ci</p>
                                        </label>
                                    </label>

                                    <label className="form-contro  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium ">
                                                Code de confirmation <span className="text-red-500">*</span>
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <input
                                                {...register('codeConfirmation', { required: true })}
                                                type="text"
                                                placeholder="Code de confirmation du client"
                                                className="input input-bordered w-full h-10 text-sm font-semibold"
                                            />
                                            <button disabled={code?.codeLoading && code?.code === null ? true : false} onClick={() => {
                                                code.generate(numeroTicket)
                                            }} className="btn btn-sm bg-main">
                                                {
                                                    code?.codeLoading && code?.code === null ? (
                                                        <>
                                                            <span className="loading loading-spinner loading-xs mx-2"></span>
                                                            generation du code
                                                        </>
                                                    ) : "Generer"
                                                }
                                            </button>
                                        </div>
                                        {
                                            code?.code != null ?
                                                <div className="bg-green-50 border px-2 py-1 mt-2 rounded">
                                                    <p className="text-xs text-green-800">{code?.code?.donnee}</p>
                                                </div> : null
                                        }

                                    </label>
                                </div>
                                <div>
                                    <label className="form-contro  w-full">
                                        <div className="label flex flex-col justify-start items-start gap-1.5">
                                            <span className="label-text  font-medium text-gray-400">
                                                Bordereau de livraison
                                            </span>
                                            <div className="w-full">
                                                {
                                                    bordereau.length !== 0 ? (
                                                        bordereau.map((bordereauLivraison, index) => (
                                                            <div key={index} className="text-black py-14 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-mdshadow-sm "
                                                                style={{
                                                                    background: "url('" + URL.createObjectURL(bordereauLivraison) + "') no-repeat center/cover"
                                                                }}
                                                                onClick={() => document.getElementById('livraison').click()}
                                                            >
                                                            </div>
                                                        ))

                                                    ) : (
                                                        <div className="text-black py-8 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm "
                                                            onClick={() => document.getElementById('livraison').click()}
                                                        >
                                                            <div className='flex justify-center mb-3'>
                                                                <UploadIcon />
                                                            </div>

                                                            <div>
                                                                <p className='text-center text-sm mx-1'>Bordereau de livraison</p>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <label className="form-contro  w-full">
                                            <div className="label flex flex-col justify-start items-start gap-1.5">
                                                <span className="label-text  font-medium text-gray-400">
                                                    Pieces d'identité du client
                                                </span>
                                                <div className="w-full">
                                                    <div className="flex gap-x-1">
                                                        {
                                                            verso.length !== 0 ? (
                                                                verso.map((cniVerso, index) => (
                                                                    <div key={index} className="text-black py-14 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-mdshadow-sm "
                                                                        style={{
                                                                            background: "url('" + URL.createObjectURL(cniVerso) + "') no-repeat center/cover"
                                                                        }}
                                                                        onClick={() => document.getElementById('verso').click()}
                                                                    >
                                                                    </div>
                                                                ))

                                                            ) : (
                                                                <div className="text-black py-8 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm "
                                                                    onClick={() => document.getElementById('verso').click()}
                                                                >
                                                                    <div className='flex justify-center mb-3'>
                                                                        <UploadIcon />
                                                                    </div>

                                                                    <div>
                                                                        <p className='text-center text-sm mx-1'>CNI verso</p>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }

                                                        {
                                                            recto.length !== 0 ? (
                                                                recto.map((cniRecto, index) => (
                                                                    <div key={index} className="py-14 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-md text-black shadow-sm "
                                                                        style={{
                                                                            background: "url('" + URL.createObjectURL(cniRecto) + "') no-repeat center/cover"
                                                                        }}
                                                                        onClick={() => document.getElementById('recto').click()}
                                                                    >
                                                                    </div>
                                                                ))

                                                            ) : (
                                                                <div className=" py-8 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-md text-gray-900 shadow-sm "
                                                                    onClick={() => document.getElementById('recto').click()}
                                                                >
                                                                    <div className='flex justify-center mb-3'>
                                                                        <UploadIcon />
                                                                    </div>

                                                                    <div>
                                                                        <p className='text-center text-sm mx-1'>CNI recto</p>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                        </label>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <SubmitButton isSubmit={isSubmit} label={'Enregistrer la livraison'} />
                    </form>
                    : (
                        <div className='flex justify-center my-28 w-full'>
                            <div className='text-center'>
                                <img className='mx-auto' src={colis} height={80} width={80} alt="" />
                                <p className='font-light mt-2  text-sm'>Livraison de l'equipement effectuée</p>
                            </div>
                        </div>
                    )

            }

            <input type="file" accept="image/jpeg, image/png " hidden id='verso' onChange={handleChangeCniVerso} />
            <input type="file" accept="image/jpeg, image/png " hidden id='recto' onChange={handleChangeCniRecto} />
            <input type="file" accept="image/jpeg, image/png " hidden id='livraison' onChange={handleChangeLivraison} />
            <div className="w-full mt-4">
                <hr />
                <div
                    className="flex mt-4"
                    sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                >

                    <Box sx={{ flex: "1 1 auto" }} />
                    <button
                        disabled={isSubmit !== null ? true : false}
                        className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
                        onClick={handleNext}
                    >
                        Poursuivre
                    </button>
                </div>
            </div>
        </>
    )
}
